import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'sections',
    label: 'Sections',
    type: types.ARRAY,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'pages',
        label: 'pages',
        type: types.ARRAY,
        children: [
          {
            key: 'name',
            label: 'Name',
            type: types.TEXT
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT
          }
        ]
      }
    ]
  }
];

const defaultProps = {
  sections: [
    {
      title: 'FF 91',
      pages: [
        {
          name: 'Gallery',
          url: '/us/ff-91/gallery'
        },
        {
          name: 'Technology',
          url: '/us/ff-91/technology'
        },
        {
          name: 'Performance',
          url: '/us/ff-91/performance'
        },
        {
          name: 'Design',
          url: '/us/ff-91/design'
        }
      ]
    },
    {
      title: 'FFZERO1',
      pages: [
        {
          name: 'Gallery',
          url: '/us/ffzero1/gallery'
        },
        {
          name: 'The UX',
          url: '/us/ffzero1/ux'
        },
        {
          name: 'Interior',
          url: '/us/ffzero1/interior'
        },
        {
          name: 'Powertrain',
          url: '/us/ffzero1/powertrain'
        },
        {
          name: 'Exterior',
          url: '/us/ffzero1/exterior'
        }
      ]
    },
  ]
};

export default {
  title: 'Sitemap',
  id: 'Sitemap',
  propsSchema,
  defaultProps
};
